import './index.css'

const NotFound = () => (
  <div className="not-found-bg-container">
    <h1 className="not-found-text">Page Not Found!</h1>
  </div>
)

export default NotFound
